import { render } from "./teachers.vue?vue&type=template&id=5a67c5a7"
import script from "./teachers.vue?vue&type=script&lang=js"
export * from "./teachers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__